<mdc-dialog>
  <mdc-dialog-container>
    <mdc-dialog-surface>

      <mdc-dialog-title>Sjekkliste for dagsoppgjør</mdc-dialog-title>

      <mdc-dialog-content>

        <app-spinner *ngIf="pending"></app-spinner>

        <ng-container *ngIf="!pending">
          <p *ngIf="sjekklistepunkter.length === 0" class="text__medium-emphasis">
            Ingen sjekklistepunkter er registrert.
          </p>

          <div [formGroup]="form">
            <div formArrayName="sjekkliste">
              <div
                *ngFor="let punkt of sjekklistepunkter; let i = index"
                class="sjekkliste__punkt"
              >
                <mdc-form-field>
                  <mdc-checkbox [formControlName]="i"></mdc-checkbox>
                  <label>{{ punkt.title }}</label>
                </mdc-form-field>
              </div>
            </div>

            <mdc-textarea
              outlined
              class="w100"
              label="Kommentar"
              formControlName="kommentar"
              rows="3"
            ></mdc-textarea>
            <mdc-helper-text *ngIf="kommentarErPakrevd" persistent>
              Påkrevd når ett eller flere punkter ikke er avkrysset
            </mdc-helper-text>
          </div>
        </ng-container>

      </mdc-dialog-content>

      <mdc-dialog-actions>
        <button mdc-button class="button-no-bg" mdcDialogAction="close">Avbryt</button>
        <button mdc-button raised [disabled]="pending || form.invalid" (click)="gaVidere()">
          Videre til kasseoppgjør
        </button>
      </mdc-dialog-actions>

    </mdc-dialog-surface>
  </mdc-dialog-container>
</mdc-dialog>
